module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"main-title":"User Manual","last-revision-date":"Last revision date: 31 May 2022"},"zh_hk":{"main-title":"用戶手冊","last-revision-date":"最後修改日期: 二零二二年五月三十一日"},"zh_cn":{"main-title":"用户手册","last-revision-date":"最后修改日期: 二零二二年五月三十一日"}}')
  delete Component.options._Ctor
}
